import type { FixedProductInput } from '@vy/types';
import React from 'react';
import { ChargesEditDataGrid } from '../ChargesEditDataGrid';
import { PROMOTIONS_CHARGES_EDIT_COLUMNS } from './promotion-charges-edit-table-consts/promotion-charges-edit-columns';

type PromotionChargesEditTableProps = {
  promotions: FixedProductInput[];
};

export const PromotionChargesEditTable: React.FC<PromotionChargesEditTableProps> = ({ promotions }) => {
  return (
    <ChargesEditDataGrid
      columns={PROMOTIONS_CHARGES_EDIT_COLUMNS}
      rows={promotions}
      columnHeaderHeight={40}
      rowHeight={66}
      disableColumnMenu
      disableRowSelectionOnClick
      hideFooter
    />
  );
};
